<template>
	<router-view />
</template>

<script>
import { getItemFromStore } from "./helpers/utils";
export default {
	watch: {
		async $route() {
			try {
				if (this.$route.path == "/plans") {
					return;
				}
				const {used, total} = getItemFromStore("credit");
				if (used >= total) {
					this.$router.push("/plans");
				}
			} catch (error) {}
		},
  	},
};
</script>

<style>
.modal-right{
	position: absolute;
	right: 0px;
	margin: 0 !important;
}
.modal-right .cus-card{
	min-height: 113vh;
}
.cus-breadcrumb a{
	color: #388fc2 !important;
}
.cus-breadcrumb a.v-breadcrumbs__item.v-breadcrumbs__item--disabled{
	color: #888 !important
}
.modal-right .v-card__actions{
	position: fixed;
	width: 100%;
	bottom: 0;
	right: inherit;
	left: inherit;
	background: #fff;
	z-index: 10;
	border-top: 1px solid #ccc;
}
.modal-right .v-card__title{
	position: fixed;
	width: 100%;
	top: 0;
	right: inherit;
	left: inherit;
	background: #fff;
	z-index: 10;
}
.modal-right .v-card__text{
	margin: 50px 0px;
	padding: 40px 20px !important;
}
.v-dialog:not(.v-dialog--fullscreen){
	max-height: 100% !important;
}
.close-btn {
	float: right;
	position: absolute;
	right: 10px;
	top: 10px;
	z-index: 10
}
.box-shadow-custom{
	box-shadow: 0 0px 3px 0 rgba(21,27,38,.15) !important;
	border: none !important;
}
.box-shadow-custom-1{
	box-shadow: 0 0px 3px 0 rgba(21,27,38,.15) !important;
	border: none !important;
}
.v-chip--label{
	border-radius: .5rem !important;
}
a.hoverLink {
	text-decoration: none;
	color: #fff
}
a.hoverLink:hover {
	text-decoration: underline;
}
.margin-div-true {
	margin-bottom: -50%
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
	border-radius: .5rem !important;
}
.v-dialog{
	border-radius: .5rem !important;
}
.v-expansion-panel::before{
	box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.9), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
}
.border-radius{
   border-radius: .5rem !important; 
}
.box-shadow-custom{
	box-shadow: 0 0px 50px 0 rgba(0,0,0,.1);
}
.box-shadow-custom-1{
	box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
}
.zoom-90{
	zoom: 90%;
}
.zoom-80{
	zoom: 80%;
}
</style>
